import { useToastController } from "@tamagui/toast";
import { Platform } from "react-native";

export default function useMaybeCopyText() {
  const { show } = useToastController();
  return (copyableText?: string) => {
    if (!copyableText) return;
    if (Platform.OS === "web") {
      navigator.clipboard
        .writeText(copyableText)
        .then(() => show("Copied to clipboard", { error: false }))
        .catch(() => show("Unable to copy to clipboard", { error: true }));
    } else show("Copy to clipboard not yet supported");
  };
}
